import React from 'react';
import Gravatar from 'react-gravatar';

import { withRouter } from 'react-router-dom';
import { CircularProgress } from 'material-ui/Progress';

import Snackbar from 'material-ui/Snackbar';
import PartialStatus from './Status/Partial';
import VisitsStatus from './Status/Visits';
import CanceledDeliveriesStatus from './Status/CanceledDeliveries';

class DocumentList extends React.Component {

    onScroll(e) {
        const el = e.target;

        if( (el.scrollHeight - el.scrollTop) === el.clientHeight ) {
            this.props.loadMore();
        }
    }

    gotoMonitoringDelivery(document) {
        this.props.history.push(`/${document.id}/`);
    }

    getItems() {
        const items = this.props.items;

        return items.map((document, index) => {
            const vehicle = document.vehicle || {};
            const user = vehicle.user || {};
            const vehicle_contract = vehicle.vehicle_contract || {};
            const vehicle_type = vehicle.vehicle_type || {};
            const weight_occupation = document.weight_occupation;
            const delivery_type = document.delivery_type || {};

            const phones = user.phones || {};

            return (
                <tr key={document.id} id={document.id} onClick={this.gotoMonitoringDelivery.bind(this, document)}>
                    <td>
                        <div className="user-info">
                            <Gravatar email={user.email || 'unknow@polibrasnet.com.br'} size={32} default="mm" className="avatar" />
                            <div>
                                <h4>{user.display_name}</h4>
                                <small>{phones.main}</small>
                            </div>
                        </div>
                    </td>

                    <td>{document.id}</td>
                    <td>{vehicle.id} - {vehicle_contract.name} / {vehicle_type.name} ({weight_occupation}%)</td>
                    <td>{delivery_type.name}</td>

                    <td><PartialStatus id={document.id} /></td>

                    <td><VisitsStatus id={document.id} /></td>

                    <td>
                        <div className="td-container">
                            <CanceledDeliveriesStatus document={document} />
                        </div>
                    </td>
                </tr>
            );
        });
    }


    render() {
        const items = this.props.items;

        if (!this.props.is_fetched) {
            return (
                <div className="text-center" style={{marginTop: '36px'}}>
                    <div><CircularProgress /></div>
                    <p><small>Carregando...</small></p>
                </div>
            );
        }

        if (!items.length) {
            return (<div className="text-center">Nenhum documento de entrega foi encontrado.</div>);
        }

        return (
            <div className="monitoring-table-container" onScroll={this.onScroll.bind(this)}>
                <table className="monitoring-table">
                    <thead>
                        <tr>
                            <th>Motorista</th>
                            <th>Documento</th>
                            <th>Veículo (% tax. ocupação)</th>
                            <th>Tipo de Rota</th>
                            <th>Entregas</th>
                            <th>Visitas</th>
                            <th>Eventos</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.getItems()}
                    </tbody>
                </table>

                <Snackbar
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                    open={this.props.fetching}
                    message={<span>Carregando...</span>}
                />
            </div>
        );
    }

}


export default withRouter(DocumentList);



// WEBPACK FOOTER //
// ./src/components/DocumentList.js